
const ResourceWhiteList = [
  "project",
  "noty",
];

export function GetInfoApiDomain() {
  const domain = process.env.REACT_APP_ENV === "production" ? "rayteams.com" : "raydevelop.com";
  return `https://api-teams-info.${domain}`;
}

export function GetAPIDomain(resource, region = "ap-northeast-2") {
  if (!ResourceWhiteList.some(x => x === resource)) {
    return null;
  }
  const domain = process.env.REACT_APP_ENV === "production" ? "rayteams.com" : "raydevelop.com";
  return `${resource === "noty" ? "wss" : "https"}://api-${region}-${resource}.${domain}`;
};

export function GetSMARTCheckDomain() {
  const domain = process.env.REACT_APP_ENV === "production" ? "rayteams.com" : "raydevelop.com";
  return `https://smartcheck.${domain}`;
};

export function GetBucket(region) {
  const bucketPrefix = process.env.REACT_APP_ENV === "production" ? "raylink-data" : "raydevelop-data";
  return `${bucketPrefix}-${region}`
}

export function millisecondsToTime(milliseconds, formatter = (n) => n.toString().padStart(2, '0')) {
  let seconds = Math.floor(milliseconds / 1000);
  let hours = Math.floor(seconds / 3600);
  seconds = seconds % 3600;
  let minutes = Math.floor(seconds / 60);
  seconds = seconds % 60;

  return {
    hour: hours > 0 ? formatter(hours) : formatter(0), 
    min: minutes > 0 ? formatter(minutes) : formatter(0), 
    sec: seconds > 0 ? formatter(seconds) : formatter(0), 
  };
}

export function getImageFileSize(fileOrUrl) {
  return new Promise((resolve, reject) => {
    if (!fileOrUrl) {
      return resolve({});
    }
    const _imageFile = new Image();
    _imageFile.onload = () => {
      const _sizes = { width: _imageFile?.width, height: _imageFile?.height, ratio: Math.floor(_imageFile?.width / _imageFile?.height * 100) / 100 };
      resolve(_sizes);
    };
    _imageFile.onerror = () => {
      resolve({});
    };
    if (fileOrUrl instanceof File) {
      _imageFile.src = URL.createObjectURL(fileOrUrl);
    } else {
      _imageFile.src = fileOrUrl;
    }
  });
};
